import { SET_FILTER_BUTTON } from './filterbutton.type';

export const setFilterButtonClick = (filter_button_click) => {
  return {
    type: SET_FILTER_BUTTON,
    payload: filter_button_click
  };
};
